import { render, staticRenderFns } from "./SystemSettingsNotifications.vue?vue&type=template&id=591031fa"
import script from "./SystemSettingsNotifications.vue?vue&type=script&lang=js"
export * from "./SystemSettingsNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports